import EntitlementColumnList from './EntitlementColumnList';
export default EntitlementColumnList;
